<template>
  <div class="weui-cell weui-cell_access" @click="select">
    <div class="weui-cell__hd">
      <label for class="weui-label">{{label}}</label>
    </div>
    <div class="weui-cell__bd">{{value}}</div>
    <div class="weui-cell__ft">
      <span v-show="!value">请选择</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
  },
  methods: {
    select() {
      var me = this,
        year = new Date().getFullYear(),
        month = new Date().getMonth() + 1,
        years = [],
        months = [
          {value: '01', label: '1月'}, 
          {value: '02', label: '2月'},
          {value: '03', label: '3月'},
          {value: '04', label: '4月'},
          {value: '05', label: '5月'},
          {value: '06', label: '6月'},
          {value: '07', label: '7月'},
          {value: '08', label: '8月'},
          {value: '09', label: '9月'},
          {value: '10', label: '10月'},
          {value: '11', label: '11月'},
          {value: '12', label: '12月'},
        ]
      for (let i = year - 20, len = year; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        months,
        {
          title: "选择年月",
          defaultValue: [year, month],
          onConfirm: function (r) {
            me.period = r[0].value + r[1].value
            me.$emit("input", me.period);
            me.$emit("change", me.period);
          }
        }
      )
    }
  }
};
</script>